<script>
export default {
  name: 'UlIconFlag',
  props: {
    country: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<template>
  <div
    class="ul-icon-flag"
    :class="[`ul-icon-flag--${country.toLowerCase()}`]"
    :title="title"
    @click="$emit('click')"
  ></div>
</template>
<style lang="scss" src="./flag.style.scss"></style>
